// extracted by mini-css-extract-plugin
export default {"root":"chat_body-module___root___f1347438","tooltip":"chat_body-module___tooltip___b4f58d95"};